import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminSidebar from '../../components/AdminSidebar';
import AdminHeader from '../../components/AdminHeader';
import './ManageUsers.css';

// Données fictives pour la démonstration
const demoUsers = [
  { id: 1, name: "Jean Dupont", email: "jean.dupont@email.com", phone: "06 12 34 56 78", status: "actif", orders: 12, lastOrder: "12/04/2025" },
  { id: 2, name: "Marie Leroy", email: "marie.leroy@email.com", phone: "07 23 45 67 89", status: "actif", orders: 8, lastOrder: "10/04/2025" },
  { id: 3, name: "Thomas Martin", email: "thomas.martin@email.com", phone: "06 34 56 78 90", status: "bloqué", orders: 5, lastOrder: "05/04/2025" },
  { id: 4, name: "Lucie Bernard", email: "lucie.bernard@email.com", phone: "07 45 67 89 01", status: "actif", orders: 15, lastOrder: "14/04/2025" },
  { id: 5, name: "Antoine Petit", email: "antoine.petit@email.com", phone: "06 56 78 90 12", status: "actif", orders: 3, lastOrder: "08/04/2025" },
];

const ManageUsers = () => {
  const [users, setUsers] = useState(demoUsers);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [viewModal, setViewModal] = useState(false);

  const navigate = useNavigate();

  // Filtrer les utilisateurs selon le terme de recherche
  const filteredUsers = users.filter(user => 
    user.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
    user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.phone.includes(searchTerm)
  );
  
  // Simuler un chargement de données depuis une API
  useEffect(() => {
    if (localStorage.getItem('adminLoggedIn') !== 'true') {
      navigate('/admin/login');
    }
  }, [navigate]);
    // Dans un cas réel, vous feriez un appel API ici
    // fetch('/api/admin/users')
    //   .then(response => response.json())
    //   .then(data => setUsers(data));
 
  
  const handleToggleStatus = (userId) => {
    setUsers(users.map(user => {
      if (user.id === userId) {
        return {
          ...user,
          status: user.status === 'actif' ? 'bloqué' : 'actif'
        };
      }
      return user;
    }));
  };
  
  const handleViewUser = (user) => {
    setSelectedUser(user);
    setViewModal(true);
  };
  
  const closeModal = () => {
    setViewModal(false);
    setSelectedUser(null);
  };

  return (
    <div className="admin-dashboard">
      <AdminSidebar />
      <div className="dashboard-content">
        <AdminHeader title="Gestion des Utilisateurs" />
        
        <div className="users-container">
          <div className="search-filter-section">
            <div className="search-box">
              <input 
                type="text" 
                placeholder="Rechercher par nom, email ou téléphone..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button className="search-button">Rechercher</button>
            </div>
            
            <div className="filter-options">
              <select defaultValue="all">
                <option value="all">Tous les utilisateurs</option>
                <option value="active">Utilisateurs actifs</option>
                <option value="blocked">Utilisateurs bloqués</option>
              </select>
              
              <select defaultValue="name">
                <option value="name">Trier par nom</option>
                <option value="latest">Trier par date d'inscription</option>
                <option value="orders">Trier par nombre de commandes</option>
              </select>
            </div>
          </div>
          
          <div className="users-table-container">
            <table className="users-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nom</th>
                  <th>Email</th>
                  <th>Téléphone</th>
                  <th>Commandes</th>
                  <th>Dernière commande</th>
                  <th>Statut</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map(user => (
                  <tr key={user.id}>
                    <td>{user.id}</td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.phone}</td>
                    <td>{user.orders}</td>
                    <td>{user.lastOrder}</td>
                    <td>
                      <span className={`status-badge ${user.status === 'actif' ? 'status-active' : 'status-blocked'}`}>
                        {user.status}
                      </span>
                    </td>
                    <td className="actions-cell">
                      <button 
                        className="action-button view-button" 
                        onClick={() => handleViewUser(user)}
                      >
                        Voir
                      </button>
                      <button 
                        className={`action-button ${user.status === 'actif' ? 'block-button' : 'unblock-button'}`}
                        onClick={() => handleToggleStatus(user.id)}
                      >
                        {user.status === 'actif' ? 'Bloquer' : 'Débloquer'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          {viewModal && selectedUser && (
            <div className="modal-backdrop">
              <div className="user-details-modal">
                <button className="close-modal" onClick={closeModal}>×</button>
                <h2>Détails de l'utilisateur</h2>
                
                <div className="user-info">
                  <div className="user-basic-info">
                    <div className="user-avatar">
                      {/* Utiliser les initiales comme avatar par défaut */}
                      {selectedUser.name.split(' ').map(n => n[0]).join('')}
                    </div>
                    <div>
                      <h3>{selectedUser.name}</h3>
                      <p>{selectedUser.email}</p>
                      <p>{selectedUser.phone}</p>
                      <p>Inscrit le: 01/01/2025</p>
                      <p className={`user-status ${selectedUser.status === 'actif' ? 'active' : 'blocked'}`}>
                        Statut: {selectedUser.status}
                      </p>
                    </div>
                  </div>
                  
                  <div className="user-order-history">
                    <h3>Historique des commandes</h3>
                    <table className="order-history-table">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Date</th>
                          <th>Restaurant</th>
                          <th>Montant</th>
                          <th>Statut</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>#ORD5623</td>
                          <td>14/04/2025</td>
                          <td>Le Gourmet</td>
                          <td>47.80€</td>
                          <td><span className="status-badge status-livré">Livré</span></td>
                        </tr>
                        <tr>
                          <td>#ORD5590</td>
                          <td>12/04/2025</td>
                          <td>Pizza Express</td>
                          <td>32.50€</td>
                          <td><span className="status-badge status-livré">Livré</span></td>
                        </tr>
                        <tr>
                          <td>#ORD5565</td>
                          <td>10/04/2025</td>
                          <td>Sushi Master</td>
                          <td>54.20€</td>
                          <td><span className="status-badge status-livré">Livré</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                
                <div className="modal-actions">
                  <button 
                    className={`action-button ${selectedUser.status === 'actif' ? 'block-button' : 'unblock-button'}`}
                    onClick={() => {
                      handleToggleStatus(selectedUser.id);
                      closeModal();
                    }}
                  >
                    {selectedUser.status === 'actif' ? 'Bloquer cet utilisateur' : 'Débloquer cet utilisateur'}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageUsers;